import {
    Grid, TableCell, TableRow, Typography
} from '@mui/material';
import { AccountWithdrawalDataRecord } from '@tassat/fred-definitions';
import { TransactionDetail } from '@tassat/text';
import React from 'react';

import { WithdrawalInstructionFields } from './types';

export const renderFields = (
    withdrawalInstruction: AccountWithdrawalDataRecord,
    fields: WithdrawalInstructionFields,
    classes: any,
    displayComponent?: 'Table' | 'TransactionDetail'
): React.ReactNode => {
    return fields.map((field) => {
        let value = withdrawalInstruction[field.valueProp];
        if (field.valueGetter) {
            value = field.valueGetter(value);
        }

        if (field.optional && !value) {
            return null;
        }

        if (displayComponent === 'Table') {
            return (
                <TableRow
                    className={classes.tableRow}
                    key={field.label}
                >
                    <TableCell className={`${classes.tableCell} ${classes.tableLabelCell}`}>{field.label}</TableCell>
                    <TableCell className={classes.tableCell}>
                        {value}
                    </TableCell>
                </TableRow>
            );
        }

        if (displayComponent === 'TransactionDetail') {
            return (
                <TransactionDetail
                    attribute={value}
                    id={`transactionDetails_withdrawal${field.label}`}
                    key={field.label}
                    label={field.label}
                />
            );
        }

        return (
            <Grid
                className={classes.detailRow}
                container
                direction='row'
                justifyContent='space-between'
                key={field.label}
                spacing={0}
                wrap='nowrap'
            >
                <Typography
                    className={classes.labelFont}
                    variant='body2'
                >
                    {field.label}
                </Typography>
                <Typography
                    className={classes.valueFont}
                    id={`withdrawalInstructionDetails_entityInfo_${field.label}`}
                    variant='body1'
                >
                    {value}
                </Typography>
            </Grid>
        );
    });
};